import { render, staticRenderFns } from "./AvukatTalepTebligatTuruPicker.vue?vue&type=template&id=4348c068"
import script from "./AvukatTalepTebligatTuruPicker.vue?vue&type=script&lang=ts"
export * from "./AvukatTalepTebligatTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports